import { render } from "./SalesListIndex.vue?vue&type=template&id=76c546fd"
import script from "./SalesListIndex.vue?vue&type=script&lang=js"
export * from "./SalesListIndex.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__